<template>
  <div class="block-processing-sides d-flex flex-wrap">
    <div
      class="block-processing-sides__processing-side mr-4 mt-2 px-2 d-flex align-items-center justify-content-center"
      v-for="processingSide in data"
      :key="processingSide">
      <button type="button" class="btn btn-sm btn-outline-primary" @click="countSide(processingSide, -1)">-</button>
      <div class="block-processing-sides__processing-side-name" :class="{'block-processing-sides__processing-side-name--empty':selectedProcessingSides[processingSide] === 0}">
        {{processingSides[processingSide]}} | {{selectedProcessingSides[processingSide]}}
      </div>
      <button type="button" class="btn btn-sm btn-outline-primary" @click="countSide(processingSide, 1)">+</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalculatePriceBlockOrientation',
  props: {
    data: {
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      selectedProcessingSides: { long: 0, short: 0 },
      processingSides: { long: 'Длинная', short: 'Короткая' }
    }
  },
  methods: {
    countSide (processingSide, value) {
      const countedValue = (this.selectedProcessingSides[processingSide] || 0) + value
      this.selectedProcessingSides = { ...this.selectedProcessingSides, [processingSide]: countedValue < 0 ? 0 : countedValue }
      this.$emit('selectProcessingSides', this.selectedProcessingSides)
    }
  }
}
</script>

<style lang="scss" scoped>
.block-processing-sides {
  &__processing-side-name {
    cursor: pointer;
    position: relative;
    height: 31px;
    margin: 0 5px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #28bd8b;
    color: #fff;
    max-width: 400px;
    box-sizing: border-box;
    padding: 5px;

    &--empty{
      background-color: #e9f8f3;
      color: #28bd8b;
    }
  }
}
</style>
